import angular from "angular";

angular
    .module('app')
    .component('videosUploadModal', {
        template: require('./videos-upload-modal.html'),
        controller: ['Upload', 'moment', '$http', controller],
        bindings: {
            close: '&',
            dismiss: '&'
        }
    });

function controller(Upload, moment, $http) {

    let $ctrl = this;

    $ctrl.result = [];
    $ctrl.courses = null;
    $ctrl.loading = false;
    $ctrl.items = [];
    $ctrl.$onInit = function () {
        $ctrl.getCoursesList();
    };

    $ctrl.filesSelected = function (files) {
        files.forEach(function (file) {
            $ctrl.items.push({
                file,
                name: file.name.replace('.mp4', ''),
                status: 'open',
                loadedSize: 0
            });
        });
    };

    $ctrl.deleteItem = function (ind) {
        $ctrl.items.splice(ind, 1);
    };

    $ctrl.submit = function () {

        if ($ctrl.loading) {
            return;
        }

        if (!$ctrl.items.length) {
            alert('No selected videos');
            return;
        }

        $ctrl.items.forEach(function (item) {
            if (item.status == 'open') {
                item.status = 'waiting';
            }
        });

        $ctrl.loading = true;

        rec(0);

        function rec(ind) {

            let item = $ctrl.items[ind];

            if (item.status != 'waiting') {
                next();
                return;
            }

            item.status = 'loading';

            let file = item.file;

            Upload
                .upload({
                    url: '/admin/videos/upload',
                    data: {
                        file: file,
                        name: item.name,
                        course_id: $ctrl.course.id
                    },
                    resumeChunkSize: '10MB',
                })
                .then(
                    function (response) {
                        console.log(response);
                        item.status = 'success';
                        item.loadedSize = file.size;
                        addToResult(item, response.data);
                        $ctrl.result.push(response.data);
                        next();
                    },
                    function (error) {
                        item.status = 'open';
                        item.uploadErrorMessage = error.data.message || 'Undefined error';
                        next();
                    },
                    function (evt) {
                        if (evt.type == 'load') {
                            item.loadedSize = evt.loaded;
                        }
                    }
                );

            function next() {
                if (ind + 1 < $ctrl.items.length) {
                    rec(ind + 1);
                } else {
                    $ctrl.loading = false;
                }
            }

        }
    };

    $ctrl.getCoursesList = function () {
        $ctrl.loading = true;
        $http
            .get('/admin/videos/get-courses-list')
            .then(
                function (response) {
                    $ctrl.courses = response.data;
                    $ctrl.loading = false;
                },
                function (error) {
                }
            );
    };

    function addToResult(item, data) {

    }

    $ctrl.dismissModal = function () {
        if (($ctrl.loading && confirm('Идет загрузка. Вы действительно хотите закрыть окно?')) || !$ctrl.loading) {
            if ($ctrl.result.length > 0) {
                $ctrl.close({$value: $ctrl.result});
            } else {
                $ctrl.close({$value: null});

            }
        }
    };
}
